import { CardholderPageModel } from "./types";
import { CardholderModel } from "./cardholder-form/types";
import { ApplicationFlows } from "../../route/application/authenticated/application-flow/types";
import { defaults } from "./defaults";

const resolveInitialValues = (
  initial: CardholderPageModel,
  admin: CardholderModel,
  flowType: ApplicationFlows,
  hasDecentralizedInvoicing: boolean,
): CardholderPageModel => {
  let resolvedInitialValues: CardholderPageModel;

  if (flowType === ApplicationFlows.ADDITIONAL_CA) {
    resolvedInitialValues = {
      cardholder: (initial && initial.cardholder) || defaults.cardholder,
      isSameAsAdmin: "no",
      hasDecentralizedInvoicing,
      decentralizedInvoicing: initial?.decentralizedInvoicing
        ? initial.decentralizedInvoicing
        : defaults.decentralizedInvoicing,
      fundsOwnershipCardholder: initial?.fundsOwnershipCardholder
        ? initial.fundsOwnershipCardholder
        : defaults.fundsOwnershipCardholder,
    };
  } else {
    resolvedInitialValues = {
      ...(initial || defaults),
      adminAsCardholder: {
        ...defaults.cardholder,
        ...(initial ? initial.adminAsCardholder : {}),
        ...admin,
      },
      hasDecentralizedInvoicing,
      decentralizedInvoicing: initial?.decentralizedInvoicing
        ? initial.decentralizedInvoicing
        : defaults.decentralizedInvoicing,
      fundsOwnershipCardholder: initial?.fundsOwnershipCardholder
        ? initial.fundsOwnershipCardholder
        : defaults.fundsOwnershipCardholder,
    };
  }

  return resolvedInitialValues;
};

export const CardholderHelpers = {
  resolveInitialValues,
};
